import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import { isSellerFollowed } from '@/redux/modules/followSeller';
import styled from 'styled-components';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import { useSelector } from 'react-redux';
type Props = {
    children: React.ReactNode;
    onClick: (event: React.MouseEvent<HTMLSpanElement>) => void;
    sellerId: number;
};
const FollowSellerLink = ({ children, onClick, sellerId }: Props) => {
    const followed = useSelector((state) => isSellerFollowed(state, sellerId));
    if (children) {
        return (
            <FollowSellerText colorBlue key={0} onClick={onClick} secondary>
                {children}
            </FollowSellerText>
        );
    }
    return (
        <FollowSellerText colorBlue key={0} onClick={onClick} secondary>
            {followed ? <FormattedMessage id="following_auctioneer" /> : <FormattedMessage id="follow_auctioneer" />}
        </FollowSellerText>
    );
};
export default React.memo<Props>(FollowSellerLink, isEqual);
const FollowSellerText = styled(Text)`
    display: inline-block;
    text-decoration: underline;
    cursor: pointer;
`;
